// === RAKVE:START ===
 // (tuto sekci spravuje scripts/patch-rakve-into-ceny.mjs)
 // Rakve platné od 5.1.2025 – kód + popis; barvu neřešíme (řeší fotka)
 const __RAKVE__ = [
  {
    "kod": "ER36",
    "nazev": "ER36 KOMES",
    "cenaBezDph": 5600,
    "skupina": "papirova",
    "fotoUrl": null
  },
  {
    "kod": "ER37",
    "nazev": "ER37 KOMES",
    "cenaBezDph": 5900,
    "skupina": "papirova",
    "fotoUrl": null
  },
  {
    "kod": "ER14",
    "nazev": "ER14 KOMES",
    "cenaBezDph": 3800,
    "skupina": "papirova",
    "fotoUrl": null
  },
  {
    "kod": "ER37",
    "nazev": "ER37 BÍLÁ KOMES",
    "cenaBezDph": 5900,
    "skupina": "papirova",
    "fotoUrl": null
  },
  {
    "kod": "PA367",
    "nazev": "PA 367",
    "cenaBezDph": 7700,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "PA367",
    "nazev": "PA 367 ŠIROKÁ",
    "cenaBezDph": 8400,
    "skupina": "siroka",
    "fotoUrl": null
  },
  {
    "kod": "PA367",
    "nazev": "PA 367 DLOUHÁ",
    "cenaBezDph": 8400,
    "skupina": "dlouha",
    "fotoUrl": null
  },
  {
    "kod": "PA100",
    "nazev": "PA 100 ECO",
    "cenaBezDph": 7700,
    "skupina": "eko",
    "fotoUrl": null
  },
  {
    "kod": "PA117",
    "nazev": "PA 117 ČERNÁ",
    "cenaBezDph": 7000,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "K327",
    "nazev": "K327",
    "cenaBezDph": 7100,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "K307",
    "nazev": "K307",
    "cenaBezDph": 7100,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "K367",
    "nazev": "K367",
    "cenaBezDph": 7100,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "K360",
    "nazev": "K360",
    "cenaBezDph": 7000,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "K370",
    "nazev": "K370",
    "cenaBezDph": 7000,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "K360",
    "nazev": "K360 ŠIROKÁ",
    "cenaBezDph": 7800,
    "skupina": "siroka",
    "fotoUrl": null
  },
  {
    "kod": "K370",
    "nazev": "K370 ŠIROKÁ",
    "cenaBezDph": 7800,
    "skupina": "siroka",
    "fotoUrl": null
  },
  {
    "kod": "PA311",
    "nazev": "PA 311",
    "cenaBezDph": 7800,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "PA321",
    "nazev": "PA 321",
    "cenaBezDph": 7800,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "PA361",
    "nazev": "PA 361",
    "cenaBezDph": 7800,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "PA381",
    "nazev": "PA 381",
    "cenaBezDph": 7800,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "PA391",
    "nazev": "PA 391",
    "cenaBezDph": 7800,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "PA337",
    "nazev": "PA 337 BÍLÁ",
    "cenaBezDph": 7200,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "PA334",
    "nazev": "PA 334 BÍLÁ",
    "cenaBezDph": 7200,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "PA199",
    "nazev": "PA 199 Kr.",
    "cenaBezDph": 9300,
    "skupina": "standard",
    "fotoUrl": null
  },
  {
    "kod": "DUBOVÁ E 691",
    "nazev": "DUBOVÁ E 691",
    "cenaBezDph": 13900,
    "skupina": "luxus",
    "fotoUrl": null
  },
  {
    "kod": "TOSCANA",
    "nazev": "TOSCANA LÍPA A OŘECH",
    "cenaBezDph": 12800,
    "skupina": "luxus",
    "fotoUrl": null
  },
  {
    "kod": "PA 990 R",
    "nazev": "PA 990 R ŠIROKÁ ABN",
    "cenaBezDph": 14600,
    "skupina": "luxus",
    "fotoUrl": null
  },
  {
    "kod": "D160V",
    "nazev": "D160V DĚTSKÁ 160 + VYBAVENÍ",
    "cenaBezDph": 4600,
    "skupina": "detska",
    "fotoUrl": null
  },
  {
    "kod": "D120V",
    "nazev": "D120V DĚTSKÁ 120 + VYBAVENÍ",
    "cenaBezDph": 4400,
    "skupina": "detska",
    "fotoUrl": null
  },
  {
    "kod": "D100V",
    "nazev": "D100V DĚTSKÁ 100 + VYBAVENÍ",
    "cenaBezDph": 4100,
    "skupina": "detska",
    "fotoUrl": null
  },
  {
    "kod": "D70V",
    "nazev": "D70V DĚTSKÁ 70 + VYBAVENÍ",
    "cenaBezDph": 3700,
    "skupina": "detska",
    "fotoUrl": null
  },
  {
    "kod": "D70N",
    "nazev": "D70N DĚTSKÁ 70 NENATŘENÁ",
    "cenaBezDph": 2000,
    "skupina": "detska",
    "fotoUrl": null
  },
  {
    "kod": "D120N",
    "nazev": "D120N DĚTSKÁ 120 NENATŘENÁ",
    "cenaBezDph": 2500,
    "skupina": "detska",
    "fotoUrl": null
  },
  {
    "kod": "D160N",
    "nazev": "D160N DĚTSKÁ 160 NENATŘENÁ",
    "cenaBezDph": 2900,
    "skupina": "detska",
    "fotoUrl": null
  }
];
// === RAKVE:END ===














export const CENIK = [
  // --- AUTO: Rakve (mapují se jako položky do Výběru služeb) ---
  ...__RAKVE__.map((r) => ({
    id: ("rakev_" + r.kod + "_" + r.nazev).replace(/\s+/g, "_"),
    kategorie: "rakve",
    kod: r.kod,
    skupina: r.skupina,
    fotoUrl: r.fotoUrl,
    nazev: r.nazev,
    cenaBezDph: r.cenaBezDph,
    dph: 12
  })),

  {
    "id": "sjednani_obradu",
    "nazev": "Sjednání smutečního obřadu",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "sjednani_obradu_online",
    "nazev": "Sjednání smutečního obřadu - Online (posílání fotek, korespondence)",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "sjednani_zpopelneni_bez_obradu",
    "nazev": "Sjednání zpopelnění bez obřadu",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "doprava_1km",
    "nazev": "Doprava rakve za 1 km",
    "cenaBezDph": 30,
    "dph": 12,
    "jednotka": "km",
    "defaultQty": 0
  },
  {
    "id": "prevoz_pausal_ck",
    "nazev": "Paušál převoz po Českém Krumlově",
    "cenaBezDph": 400,
    "dph": 12,
    "jednotka": "paušál",
    "defaultQty": 1
  },
  {
    "id": "prevoz_krematorium_cb",
    "nazev": "Paušál převoz do krematoria České Budějovice",
    "cenaBezDph": 1800,
    "dph": 12,
    "jednotka": "paušál",
    "defaultQty": 1
  },
  {
    "id": "manipulace_rakvi_nositky",
    "nazev": "Manipulace s rakví - nosítky (1 osoba 250 Kč, 2 osoby 500 Kč)",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "manipulace_rakvi_pat",
    "nazev": "Manipulace s rakví - nosítky (každé patro)",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "manipulace_telo_abn_rakev",
    "nazev": "Manipulace s tělem v ABN rakvi (navíc 2 osoby x 250 Kč + úkony 500 Kč)",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "manipulace_urnou",
    "nazev": "Manipulace s urnou (1x)",
    "cenaBezDph": 150,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "rizeni_pohrebu",
    "nazev": "Řízení pohřbu",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "stejnokroj_osoba",
    "nazev": "Použití stejnokroje - osoba",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "nosic_osoba_hod",
    "nazev": "Nosič - osoba (hodinová sazba)",
    "cenaBezDph": 300,
    "dph": 12,
    "jednotka": "hod",
    "defaultQty": 1
  },
  {
    "id": "ulozeni",
    "nazev": "Uložení",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "ustrojeni",
    "nazev": "Ustrojení",
    "cenaBezDph": 100,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "obleceni",
    "nazev": "Oblečení",
    "cenaBezDph": 800,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "obleceni_infekcni",
    "nazev": "Oblečení (infekční osoby)",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "obleceni_rubase",
    "nazev": "Oblečení rubáše",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "umyvani",
    "nazev": "Umývání",
    "cenaBezDph": 700,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "holeni",
    "nazev": "Holení",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "liceni_malovani_nehtu",
    "nazev": "Líčení zesnulé, malování nehtů",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "vystaveni_zesnuleho",
    "nazev": "Vystavení zesnulého",
    "cenaBezDph": 300,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "vystaveni_zesnuleho_covid",
    "nazev": "Vystavení zesnulého - Covid 19",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "vystaveni_bez_obradu_vystavni_mistnost_katafalk",
    "nazev": "Vystavení zesnulého bez obřadu - výstavní místnost + katafalk",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "foto_zesnuleho",
    "nazev": "Foto zesnulého",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "pruvod_10min_hrbitov",
    "nazev": "Průvod 1×10 minut - hřbitov",
    "cenaBezDph": 100,
    "dph": 12,
    "jednotka": "min",
    "defaultQty": 10
  },
  {
    "id": "pruvod_10min_vozem",
    "nazev": "Průvod 1×10 minut pohřebním vozem",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "min",
    "defaultQty": 10
  },
  {
    "id": "chladici_zarizeni_den",
    "nazev": "Chladící zařízení - 1 den",
    "cenaBezDph": 400,
    "dph": 12,
    "jednotka": "den",
    "defaultQty": 1
  },
  {
    "id": "mrazici_zarizeni_den",
    "nazev": "Mrazící zařízení - 1 den",
    "cenaBezDph": 800,
    "dph": 12,
    "jednotka": "den",
    "defaultQty": 1
  },
  {
    "id": "chlazeni_24h",
    "nazev": "Chladící zařízení - 1 den (Správa hřbitova ČK)",
    "cenaBezDph": 400,
    "dph": 12,
    "jednotka": "den",
    "defaultQty": 1
  },
  {
    "id": "mrazeni_24h",
    "nazev": "Mrazící zařízení - 1 den (Správa hřbitova ČK)",
    "cenaBezDph": 800,
    "dph": 12,
    "jednotka": "den",
    "defaultQty": 1
  },
  {
    "id": "katafalk_obradni_sin",
    "nazev": "Katafalk (v obřadní síni / kapli)",
    "cenaBezDph": 300,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "pronajem_kaple",
    "nazev": "Pronájem - kaple",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "pronajem_obradni_sin",
    "nazev": "Pronájem - obřadní síň",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "pojizdny_katafalk",
    "nazev": "Pojízdný katafalk",
    "cenaBezDph": 600,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "vystaveni_kvetinove_vyzdoby_1ks",
    "nazev": "Vystavení květinové výzdoby - 1 ks",
    "cenaBezDph": 50,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "likvidace_kvetinove_vyzdoby",
    "nazev": "Likvidace květinové výzdoby po obřadu",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "online_prenos",
    "nazev": "Online přenos posledního rozloučení",
    "cenaBezDph": 1200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "promitani_fotografii",
    "nazev": "Promítání fotografií",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "priprava_prezentace_do30",
    "nazev": "Příprava prezentace k promítání - do 30 ks fotografií včetně videa hudby",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "priprava_prezentace_nad30",
    "nazev": "Příprava prezentace k promítání - nad 30 fotografií včetně videa hudby",
    "cenaBezDph": 1600,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "zaznam_z_obradu",
    "nazev": "Záznam z obřadu",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "vystaveni_fotografie",
    "nazev": "Vystavení fotografie",
    "cenaBezDph": 100,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "zapujceni_lucerny",
    "nazev": "Zapůjčení lucerny",
    "cenaBezDph": 100,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "zapujceni_stojanu",
    "nazev": "Zapůjčení stojanu",
    "cenaBezDph": 100,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "obrad_s_urnou_zapujceni_urny",
    "nazev": "Obřad s urnou - zapůjčení urny dle výběru",
    "cenaBezDph": 400,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "obrad_s_urnou_zapujceni_rakve",
    "nazev": "Obřad s urnou - zapůjčení rakve",
    "cenaBezDph": 800,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "dechova_hudba_od",
    "nazev": "Dechová hudba (od 6500 Kč do 8000 Kč)",
    "cenaBezDph": 6500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1,
    "poznamka": "Cena dle počtu muzikantů a ujetých km (v případě potřeby přepiš)."
  },
  {
    "id": "hra_varhany_s_dechovou",
    "nazev": "Hra na varhany s dechovou hudbou",
    "cenaBezDph": 300,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "hra_na_varhany",
    "nazev": "Hra na varhany",
    "cenaBezDph": 600,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "pronajem_varhan",
    "nazev": "Pronájem varhan",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "reprodukovana_hudba",
    "nazev": "Reprodukovaná hudba",
    "cenaBezDph": 900,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "reprodukovana_hudba_mimo_sin",
    "nazev": "Reprodukovaná hudba mimo obřadní síň + pronájem cestovního reproduktoru",
    "cenaBezDph": 2400,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "civilni_recnik_v_sini",
    "nazev": "Civilní řečník v obřadní síni",
    "cenaBezDph": 800,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "civilni_recnik_ke_hrobu",
    "nazev": "Civilní řečník - ke hrobu",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "civilni_recnik_mimo_ck",
    "nazev": "Civilní řečník - mimo ČK (plus 400 Kč za čas a dopravu)",
    "cenaBezDph": 800,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1,
    "poznamka": "Když je potřeba, přičti ručně +400."
  },
  {
    "id": "obradnik_v_sini_pouze_pri_hudbe",
    "nazev": "Obřadník v obřadní síni - pouze při hudbě",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "obradnik_mimo_ck",
    "nazev": "Obřadník mimo ČK (plus 400 Kč za čas a dopravu)",
    "cenaBezDph": 900,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1,
    "poznamka": "Když je potřeba, přičti ručně +400."
  },
  {
    "id": "pronajem_drevenych_zidli_kus",
    "nazev": "Pronájem dřevěných židlí - kus",
    "cenaBezDph": 150,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "alternativni_misto_organizace",
    "nazev": "Alternativní místo rozloučení (louka/les/park/… ) - organizace",
    "cenaBezDph": 3000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "asistence_alternativni_rozlouceni_hod",
    "nazev": "Asistence při alternativním rozloučení - hodinová sazba 1 osoba",
    "cenaBezDph": 300,
    "dph": 12,
    "jednotka": "hod",
    "defaultQty": 1
  },
  {
    "id": "rezijni_naklady",
    "nazev": "Režijní náklady",
    "cenaBezDph": 600,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "rezijni_naklady_bez_obradu",
    "nazev": "Režijní náklady bez obřadu",
    "cenaBezDph": 400,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "ukony_zamestnancu",
    "nazev": "Úkony zaměstnanců",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "cekaci_doba_zapocata_hod",
    "nazev": "Čekací doba za každou započatou hodinu - pohřeb/výjezd (1 osoba=200 Kč)",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "hod",
    "defaultQty": 1
  },
  {
    "id": "cekaci_doba_dpp_nosic_osoba",
    "nazev": "Čekací doba pro DPP nosiče na pohřbu - osoba navíc",
    "cenaBezDph": 150,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "prevoz_tela_cb_krematorium_pausal",
    "nazev": "Převoz jednoho těla do Č. B. krematoria - paušál",
    "cenaBezDph": 1800,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "prevoz_ck_pausal",
    "nazev": "Převoz Český Krumlov - paušál",
    "cenaBezDph": 400,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "zajisteni_prevozu_mimo_uredni_hodiny",
    "nazev": "Zajištění převozu zemřelého mimo úřední hodiny",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "konani_pohrebu_so_ne",
    "nazev": "Konání pohřbu v sobotu / v neděli - za jednu osobu",
    "cenaBezDph": 1000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "konani_pohrebu_svatky",
    "nazev": "Konání pohřbu ve svátek - za jednu osobu",
    "cenaBezDph": 2000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "dezinfekce_vozu",
    "nazev": "Dezinfekce vozu (v ojedinělých případech)",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "transportni_rakev_vc_desinfekce",
    "nazev": "Použití transportní rakve včetně dezinfekce",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "transportni_nositka_vc_desinfekce",
    "nazev": "Použití transportních nosítek včetně dezinfekce",
    "cenaBezDph": 500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "uprava_tela_socialni_pohreb",
    "nazev": "Úprava těla zemřelého pro sociální pohřby",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "privezeni_urny_cb",
    "nazev": "Přivezení urny z ČB",
    "cenaBezDph": 100,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "otevreni_a_zalepeni_urny",
    "nazev": "Otevření urny + zalepení (á100 + á100)",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "odsyp_popela",
    "nazev": "Odsyp popela",
    "cenaBezDph": 100,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "ulozeni_urny_mesic",
    "nazev": "Uložení urny - každý další započatý měsíc",
    "cenaBezDph": 200,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "doklady_odvoz_cizince",
    "nazev": "Zajištění dokladů pro odvoz cizince mimo ČR (matrika, AJ, úmrtní pas, hygiena, celní správa, ambasáda)",
    "cenaBezDph": 4000,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1,
    "poznamka": "Dle náročnosti externí služba až 7000 (případně přepiš)."
  },
  {
    "id": "likvidace_zinkove_vlozky",
    "nazev": "Likvidace zinkové vložky včetně otevření, likvidace a manipulace",
    "cenaBezDph": 2500,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "kondolence",
    "nazev": "Kondolence",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks"
  },
  {
    "id": "zivy_houslista",
    "nazev": "Živý houslista",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks"
  },
  {
    "id": "zivy_trumpetista",
    "nazev": "Živý trumpetista",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks"
  },
  {
    "id": "kvetinova_vyzdoba_sarger",
    "nazev": "Květinová výzdoba – šarger (dle domluvy)",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks"
  },
  {
    "id": "kvetinova_vyzdoba_vynaseni",
    "nazev": "Květinová výzdoba – vynášení / manipulace (dle domluvy)",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks"
  },
  {
    "id": "pronajem_chladici_komora",
    "nazev": "Pronájem - chladící komora",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "zpev",
    "nazev": "Zpěv",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "autobus_sm_hosti",
    "nazev": "Autobus pro smuteční hosty",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "umrtni_oznameni",
    "nazev": "Úmrtní oznámení",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "vystaveni_vence_ks",
    "nazev": "Vystavení věnce ks",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "vystaveni_kytice_ks",
    "nazev": "Vystavení kytice ks",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "vence",
    "nazev": "Věnce",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "kytice",
    "nazev": "Kytice",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "stuhy",
    "nazev": "Stuhy",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "prani_objednavatele",
    "nazev": "Přání objednavatele",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "rozptyl",
    "nazev": "Rozptyl",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "kvetinova_vyzdoba",
    "nazev": "Květinová výzdoba",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "kremace",
    "nazev": "Kremace",
    "cenaBezDph": 5937.70,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "rakev",
    "nazev": "Rakev (cena)",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "vlozka_zinek",
    "nazev": "Vložka zinek - pozink",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "souprava",
    "nazev": "Souprava",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "rubas",
    "nazev": "Rubáš",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "krajka",
    "nazev": "Krajka",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "poduska",
    "nazev": "Poduška",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "vak",
    "nazev": "Vak",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "svice",
    "nazev": "Svíce kg - ks",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "krizky",
    "nazev": "Křížky",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "provize",
    "nazev": "Provize ze zajištěných služeb",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "letovani_vlozky",
    "nazev": "Letování vložky",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "umyvani_obleceni_ulozeni_ustrojeni",
    "nazev": "Umývání, oblečení, uložení ustrojení",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "prevoz_jednoho_tela_cb_krematorium",
    "nazev": "Převoz jednoho těla do Č. B. Krematoria",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "pruvod",
    "nazev": "Průvod (min)",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "nositka",
    "nazev": "Nosítka",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "telefony_telegramy",
    "nazev": "Telefony - telegramy",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
  {
    "id": "uredni_urna",
    "nazev": "Úřední urna",
    "cenaBezDph": 0,
    "dph": 12,
    "jednotka": "ks",
    "defaultQty": 1
  },
];
export default CENIK;
